import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Link } from "react-router-dom";
import { _Api, _PdfApi } from "../../api/_call";
import TableColumnModal from "../../common/modules/tableColumn";
import ConfirmationModel from "../../common/modules/confirmationmodel";
import AgentModel from "../../common/modules/agentmodal";
import { stocktransfertablehead } from "../../common/Tablehead";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Pagination } from "../../common/Pagination";
import {
  toFormatPrice,
  toUnformatPrice,
  transactionTotals,
  buildTodayDateRange,
  buildLastMonthDateRange,
  buildStatusDateMapFromState,
} from "../../common/helpers/function";
import Select, { components } from "react-select";
import {
  error,
  loading,
  Updateloading,
} from "../../common/helpers/toastify";
import {
  status_transfer_class,
  status_priority,
} from "../../common/helpers/status_class";
import { useSelector } from "react-redux";
import { Stocktransferdetails } from "../../transaction/subTables/StockTransfer/stocktransferdetails";
import ProductModal from "../../common/modules/ProductModal";
import ProductImageSliderModal from "../../common/modules/productImageslider";
import SocialModal from "../../common/modules/SocialModal/SocialModal";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../common/helpers/formatDate";
import TableLoader from "../../../admin/common/TableLoader";

// Column order mirrors stocktransfertablehead — index-aligned so a
// column's sort key / visibility can be looked up by its position.
const SORT_KEYS = [
  "date",
  "tf_no",
  "from",
  "ship_to",
  "sku",
  "qty",
  "delivery_date",
  "due_days",
  "amount",
  "status",
  "priority",
  null,
  null,
  null,
  null,
  null,
  null,
];
const SORT_ACCESSORS = {
  date: (r) => r?.transaction_date || r?.createdAt,
  tf_no: (r) => r?.st_no,
  from: (r) => r?.transfer_from_loc_name,
  ship_to: (r) => r?.transfer_to_location_name,
  sku: (r) => Number(r?.sku) || 0,
  qty: (r) => Number(r?.total_quantity) || 0,
  delivery_date: (r) => r?.delivery_date_unformated || r?.delivery_date,
  due_days: (r) => Number(r?.due_days) || 0,
  amount: (r) => toUnformatPrice(r?.total_amount),
  status: (r) => r?.status?.st_status,
  priority: (r) => r?.status?.priority,
};

const Stock_transfer = (props) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const dataFetched = useRef();
  const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const totalcountsnumber = useSelector((state) => state.app.totalcountsnumber);
  const [limit, setLimit] = useState(100);
  const [filtername, setFiltername] = useState("");
  const [datefilter, setDatefilter] = useState(
    () => buildLastMonthDateRange().filter,
  );
  const [datelable, setDatelable] = useState("LastMonth");
  const [pdfLoadingIds, setPdfLoadingIds] = useState(new Set());
  const [stExportFormat, setStExportFormat] = useState("xlsx");
  const [stSampleFormat, setStSampleFormat] = useState("xlsx");
  const datePickerRef = useRef(null);
  const statusDateSyncRef = useRef(true);

  const [statusDates, setStatusDates] = useState(() => {
    const lastMonth = buildLastMonthDateRange();
    const today = buildTodayDateRange();
    return {
      pending: lastMonth,
      approved: lastMonth,
      transit: lastMonth,
      completed: today,
      cancelled: today,
    };
  });

  const statusValueToCountKey = {
    2: "pending",
    1: "approved",
    3: "transit",
    4: "completed",
    0: "cancelled",
  };

  const getStatusCountKey = (statusValue) =>
    statusValueToCountKey[statusValue] || "pending";

  const applyStatusDateToUi = (statusKey) => {
    const next = statusDates[statusKey] || buildLastMonthDateRange();
    const nextStart = next.filter?.[0];
    const nextEnd = next.filter?.[1];
    const sameRange = Boolean(
      datefilter[0] &&
      datefilter[1] &&
      nextStart &&
      nextEnd &&
      new Date(datefilter[0]).getTime() === new Date(nextStart).getTime() &&
      new Date(datefilter[1]).getTime() === new Date(nextEnd).getTime(),
    );
    if (sameRange) {
      if (datelable !== next.label) setDatelable(next.label);
      return false;
    }
    setDatefilter([new Date(nextStart), new Date(nextEnd)]);
    setDatelable(next.label);
    return true;
  };

  const updateCurrentStatusDate = (filter, label) => {
    const statusKey = getStatusCountKey(filterchangestatus);
    setStatusDates((prev) => ({
      ...prev,
      [statusKey]: { filter, label },
    }));
    setDatefilter(filter);
    setDatelable(label);
  };

  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === "Today") {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      updateCurrentStatusDate([todayStart, new Date()], "Today");
    } else if (lable === "Yesterday") {
      const yesterdayStart = new Date(MainDate.setDate(MainDate.getDate() - 1));
      yesterdayStart.setHours(0, 0, 0, 0);
      const yesterdayEnd = new Date(yesterdayStart);
      yesterdayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([yesterdayStart, yesterdayEnd], "Yesterday");
    } else if (lable === "7days") {
      const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7));
      sevendays.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([sevendays, todayEnd], "7days");
    } else if (lable === "30days") {
      const days = new Date(MainDate.setDate(MainDate.getDate() - 30));
      days.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([days, todayEnd], "30days");
    } else if (lable === "ThisMonth") {
      const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
      firstDay.setHours(0, 0, 0, 0);
      const lastDay = new Date(
        MainDate.getFullYear(),
        MainDate.getMonth() + 1,
        0,
      );
      lastDay.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([firstDay, lastDay], "ThisMonth");
    } else if (lable === "LastMonth") {
      const start = new Date();
      start.setDate(start.getDate() - 30);
      start.setHours(0, 0, 0, 0);
      updateCurrentStatusDate([start, new Date()], "LastMonth");
    }
  };

  const [statement, setStatement] = useState("");
  const [transfer_sataus, settransfer_sataus] = useState([]);
  const [stocktransferlist, setStocktransferlist] = useState([]);
  const [agentvalue, setAgentvalue] = useState();
  const [AWBvalues, setAWBvalue] = useState();
  const [imageid, setImageid] = useState();
  const [Productmodaldata, setProductmodaldata] = useState([]);
  const [transfer_priority, settransfer_priority] = useState([]);
  const [newcolumndata, setnewcolumndata] = useState(stocktransfertablehead);
  const [skip, setSkip] = useState();
  const [filterchangestatus, setfilterchangestatus] = useState(2);
  const [selectedLabel, setSelectedLabel] = useState("Pending");
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [datalodaer, setDatsLodaer] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" },
    );
  };
  // const colorStyles = {
  //   option: (styles, { data }) => {
  //     return {
  //       ...styles,
  //       backgroundColor: data.color,
  //     }
  //   },
  // }
  const colorStyles = {
    option: (styles, { data }) => ({
      ...styles,
      backgroundColor: data.color,
      color: "#fff",
      fontSize: "16px",
      padding: "12px 16px",
      fontFamily: "inherit",
      cursor: "pointer",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    control: (base) => ({
      ...base,
      fontSize: "14px",
      fontFamily: "inherit",
      minHeight: "40px",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
      marginTop: "8px",
      padding: "6px 12px",
      position: "relative",
    }),
  };
  const CustomMenu = (props) => (
    <components.Menu {...props}>
      {/* Arrow */}
      <div
        style={{
          position: "absolute",
          top: "-10px",
          left: "calc(100% - 75px)", // position arrow near the left edge of the select box
          width: 0,
          height: 0,
          borderLeft: "12px solid transparent",
          borderRight: "12px solid transparent",
          borderBottom: "16px solid #fff",
          // boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        }}
      />
      {props.children}
    </components.Menu>
  );
  const select_transfer_status = (index, value, transfer_id) => {
    setStatement("Change Status");
    settransfer_sataus([
      { index: index, status: value, transfer_id: transfer_id },
    ]);
    if (
      value?.value === 3 &&
      generalsettings?.data?.generalsetup?.logistic_status === "1"
    ) {
      document.querySelector("#statustransit_query_select").click();
    } else {
      document.querySelector("#status_query_select").click();
    }
  };
  const priorityarray = [
    { label: "low", value: 0, color: "#D9D9D9", className: "low-text" },
    { label: "medium", value: 1, color: "#D2E4FF", className: "medium-text" },
    { label: "high", value: 2, color: "#FFD2D9", className: "high-text" },
  ];
  const filter_status = [
    { label: t("Pending"), labelcount: "pending", value: 2, color: "yellow" },
    {
      label: t("Approved"),
      labelcount: "approved",
      value: 1,
      color: "main-green",
    },
    { label: t("Transit"), labelcount: "transit", value: 3, color: "transit" },
    {
      label: t("Completed"),
      labelcount: "completed",
      value: 4,
      color: "light-blue",
    },
    {
      label: t("Canceled"),
      labelcount: "cancelled",
      value: 0,
      color: "danger",
    },
  ];
  // Maps the status-filter bar's color names to real CSS colors, so the
  // active top-level tab's underline matches whichever status is selected.
  const STATUS_COLOR_HEX = {
    yellow: "#F9BC44",
    "main-green": "#5CC7C1",
    danger: "#FF5757",
    "light-blue": "#68B8F2",
    transit: "#97BFD9",
  };
  const activeTabUnderlineColor =
    STATUS_COLOR_HEX[
      filter_status.find((f) => f.value === filterchangestatus)?.color
    ] || "#5CC7C1";
  const select_transfer_priority = (index, value, transfer_id) => {
    setStatement("Change Priority");
    settransfer_priority([
      { index: index, status: value, transfer_id: transfer_id },
    ]);
    var mainarray = [...stocktransferlist];
    mainarray[index]["status"] = {
      ...mainarray[index]["status"],
      priority: value?.value,
    };
    setStocktransferlist(mainarray);
    document.querySelector("#status_query_select").click();
  };

  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getstocktransfer(current, "", "");
  };
  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Getstocktransfer(currentPage, limit, filterchangestatus, search);
  };
  const getlimit = (limit) => {
    setLimit(limit);
    Getstocktransfer(1, limit);
    setstate({ ...state, currentPage: 1 });
  };
  const [excuteTable, setexcuteTable] = useState(false);

  const sortedList = useMemo(() => {
    const accessor = SORT_ACCESSORS[sortConfig.key];
    if (!accessor) return stocktransferlist;
    const sorted = [...stocktransferlist].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null) return 1;
      if (bv === undefined || bv === null) return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [stocktransferlist, sortConfig]);

  const Getstocktransfer = useCallback(
    async (current, firstlimit, filter_status, search) => {
      setexcuteTable(false);
      setDatsLodaer(true);
      // setfilterchangestatus(filter_status)
      try {
        setTimeout(async function () {
          const postdata = {
            search: search ? search : "",
            limit: firstlimit ? firstlimit : limit,
            skip: skip === 0 ? skip : current ? (current - 1) * limit : 0,
            status:
              filter_status === 0
                ? 0
                : filter_status
                  ? filter_status
                  : filterchangestatus,
            start_date: datefilter ? datefilter[0] : "",
            end_date: datefilter ? datefilter[1] : "",
          };
          let resstocktransfer = await _Api(
            postdata,
            `api/v1/Inventory/stocktransfer/getStockTransferList`,
          );
          if (resstocktransfer.code === 200) {
            setexcuteTable(true);
            if (!(current && Number(current) > 1)) {
              transactionTotals({
                start_date: datefilter[0],
                end_date: datefilter[1],
                statusDateMap: buildStatusDateMapFromState(statusDates),
                moduleKey: "ST",
              });
            }
            setStocktransferlist(resstocktransfer?.data);
            setstate({
              ...state,
              totalPages: Math.ceil(resstocktransfer?.count / postdata.limit),
              currentPage: current ? current : 1,
            });
            setDatsLodaer(false);
            dataFetched.current = false;
          }
        }, 100);
      } catch (err) {
        console.log(err, "err");
      }
    },
    [datefilter, limit, skip, state, filterchangestatus, statusDates],
  );
  const Getstocktransferstatus = async () => {
    const handleValidation = (e) => {
      let formIsValid = true;
      if (transfer_sataus[0].status?.value === 3) {
        if (!agentvalue?.value) {
          formIsValid = false;
          error(t("Select the Agent Option!!"));
        }
        if (!AWBvalues) {
          formIsValid = false;
          error(t("Enter the AWB NO.!!"));
        }
      } else {
        formIsValid = true;
      }
      return formIsValid;
    };
    if (handleValidation) {
      let GetloadingID = loading();
      try {
        const postdata = {
          logistic_id: agentvalue?.value ? agentvalue?.value : "",
          awb_number: AWBvalues ? AWBvalues : "",
          status: transfer_sataus[0].status?.value,
          stock_transfer_id: transfer_sataus[0].transfer_id,
        };
        let resstocktransferstatus = await _Api(
          postdata,
          `api/v1/Inventory/stocktransfer/editStockTransferStatus`,
        );
        if (resstocktransferstatus?.code === 200) {
          Updateloading(t, GetloadingID, t("Successfully Status Updated!!"));
          Getstocktransfer();
        } else {
          Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
        }
      } catch (err) {
        console.log(err, "err");
        Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
      }
    }
  };
  const Getstocktransferpriority = async () => {
    let GetloadingID = loading();
    try {
      const postdata = {
        status: transfer_priority[0].status?.value,
        stock_transfer_id: transfer_priority[0].transfer_id,
      };
      let resstocktransferstatus = await _Api(
        postdata,
        `api/v1/Inventory/stocktransfer/editStockTransferPriority`,
      );
      if (resstocktransferstatus?.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Priority Updated!!"));
        Getstocktransfer();
      } else {
        Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
    }
  };
  const setSubTable = async (id) => {
    var e = document.querySelector("#table-btn_" + id);
    var classList_ = e.classList;
    if (classList_.contains("rotate-90")) {
      classList_.remove("rotate-90");
      let alllist_data = [...stocktransferlist];
      alllist_data
        .filter((item) => item.id === id)
        .forEach((result) => {
          result.subTable = null;
        });
      setStocktransferlist(alllist_data);
    } else {
      classList_.add("rotate-90");
      let alllist_data = [...stocktransferlist];
      const postdata = {
        st_order_id: id,
      };
      let prioritydata = await _Api(
        postdata,
        `api/v1/Inventory/stocktransfer/getSTDetails`,
      );
      if (prioritydata?.code === 200) {
        var html_ = Stocktransferdetails(
          prioritydata,
          setImageid,
          setProductmodaldata,
          t,
        );
        alllist_data
          .filter((item) => item.id === id)
          .forEach((result) => {
            result.subTable = html_;
          });
      }
      setStocktransferlist(alllist_data);
    }
  };
  const handleOpenPDF = async (id) => {
    if (pdfLoadingIds.has(id)) return;
    setPdfLoadingIds((prev) => new Set(prev).add(id));
    let GetloadingID = loading();
    try {
      const blobData = await _PdfApi(
        { id },
        "api/v1/Inventory/stocktransfer/generateStockTransferPdf",
      );
      const blob = new Blob([blobData], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
      Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
    } catch (err) {
      Updateloading(t, GetloadingID, t("somthing went wrong"), "error");
    } finally {
      setPdfLoadingIds((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
    }
  };

  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      Getstocktransfer();
    }
    // eslint-disable-next-line
  }, [datefilter]);

  useEffect(() => {
    const statusKey = getStatusCountKey(filterchangestatus);
    const rangeChanged = applyStatusDateToUi(statusKey);
    if (statusDateSyncRef.current) {
      statusDateSyncRef.current = false;
      return;
    }
    if (!rangeChanged) {
      Getstocktransfer(1, limit, filterchangestatus);
    }
    // eslint-disable-next-line
  }, [filterchangestatus, selectedLabel]);

  const downloadexclsheet = async (format = stExportFormat) => {
    const GetloadingID = loading();
    try {
      const postdata = {
        format: format || "xlsx",
        search: filtername || "",
        status:
          filterchangestatus === 0
            ? 0
            : filterchangestatus
              ? filterchangestatus
              : "",
        start_date: datefilter ? datefilter[0] : "",
        end_date: datefilter ? datefilter[1] : "",
      };
      const res = await _Api(
        postdata,
        "api/v1/Inventory/stocktransfer/stockTransferExport",
      );
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, res?.message || t("Export started"));
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.errors || res?.error || t("Something went wrong"),
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  };

  const downloadSampleSheet = async (format = stSampleFormat) => {
    const GetloadingID = loading();
    try {
      const exportFormat =
        String(format).toLowerCase() === "csv" ? "csv" : "xlsx";
      const res = await _Api(
        { format: exportFormat },
        "api/v1/Inventory/stocktransfer/stockTransferSampleTemplate",
      );
      if (res?.code === 200 && res?.filexlsx) {
        const a = document.createElement("a");
        a.hidden = true;
        a.href = res.filexlsx;
        a.download = `StockTransfer_Sample.${exportFormat}`;
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        a.remove();
        Updateloading(
          t,
          GetloadingID,
          res?.message || t("Sample template downloaded"),
        );
      } else {
        Updateloading(
          t,
          GetloadingID,
          res?.message || res?.error || t("Could not download sample template"),
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(
        t,
        GetloadingID,
        t("Could not download sample template"),
        "error",
      );
    }
  };
  return (
    <React.Fragment>
      <div className="main-body" style={{ paddingTop: "0px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                style={{
                  position: "sticky",
                  top: "128px",
                  zIndex: 5,
                  flexShrink: 0,
                  background: " #f9f9fb",
                  width: "100%",
                  paddingTop: "15px",
                  opacity: 0.9,
                }}
              >
                <h1 className="main-body-heading">{t("Transaction")}</h1>
                <div className="main-body-top-tab-bar">
                  <div
                    className="main-body-top-tab-bar-left-col nav nav-pills"
                    role="tablist"
                  >
                    <Link
                      className={
                        parmissiondatashow?.purchase_order?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                      to="/app/inventory"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Purchase Order")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.PO?.total
                          ? totalcountsnumber?.PO?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      className={
                        parmissiondatashow?.inventory_transaction_purchase?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                      to="/app/inventory/transactionPurchase"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Purchase")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.PU?.total
                          ? totalcountsnumber?.PU?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      className="main-body-top-tab-bar-left-col-a nav-link active"
                      to="/app/inventory/stock_transfer"
                      style={{
                        "--tab-underline-color": activeTabUnderlineColor,
                      }}
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Transfer")}
                      </span>
                      <span
                        className="num-tab"
                        data-bs-toggle="collapse"
                        data-bs-target="#tStockTransfer"
                      >
                        {totalcountsnumber?.ST?.total
                          ? totalcountsnumber?.ST?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      className={
                        parmissiondatashow?.inventory_transaction_stock_Receive
                          ?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                      to="/app/inventory/transactionStockReceive"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Receive")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.SR ? totalcountsnumber?.SR : "0"}
                      </span>
                    </Link>
                    <Link
                      className="main-body-top-tab-bar-left-col-a nav-link"
                      to="/app/inventory/stockAdjustment"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Adjustment")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.SA?.total
                          ? totalcountsnumber?.SA?.total
                          : "0"}
                      </span>
                    </Link>
                  </div>
                  <div className="main-body-top-tab-bar-right-col">
                    <Link
                      to="/app/inventory/createTransferInventory"
                      className={
                        parmissiondatashow?.inventory_transaction_stock_transfer
                          ?.Add
                          ? "main-body-top-tab-bar-right-col-a"
                          : "d-none"
                      }
                    >
                      <img
                        src={
                          base_url_assets + "images/icons/plus-circle-white.png"
                        }
                        alt=""
                      />
                      <span className="main-body-top-tab-bar-right-col-a-text">
                        {t("Create")}
                      </span>
                    </Link>
                  </div>
                </div>
                <div id="tStockTransfer" className="collapse show">
                  <div className="main-body-top-color-bar">
                    {filter_status.map((result, key) => {
                      return (
                        <div
                          className="main-body-top-color-bar-single"
                          onClick={() => {
                            Getstocktransfer("", "", result?.value);
                            setSelectedLabel(result?.label);
                            setfilterchangestatus(result?.value);
                            setSkip(0);
                          }}
                          key={key}
                        >
                          <div
                            className={
                              "main-body-top-color-bar-single-color " +
                              result?.color +
                              "-bg"
                            }
                          />
                          <span
                            className={
                              "main-body-top-color-bar-single-color-status " +
                              result?.color +
                              "-text"
                            }
                          >
                            {result?.label}
                          </span>
                          <span>
                            {totalcountsnumber?.ST?.[`${result?.labelcount}`]
                              ? totalcountsnumber?.ST?.[`${result?.labelcount}`]
                              : "0"}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="main-body-top-status-bar">
                  <Select
                    className=" select-set select p-0 main-content-wrapper-body-top-status-bar-select-num"
                    options={selectOptions}
                    value={{ label: limit, value: limit }}
                    onChange={(e) => {
                      setLimit(e.value);
                      getlimit(e.value);
                    }}
                    isSearchable={false}
                  />
                  <div className="main-body-top-status-bar-filter">
                    <input
                      type="text"
                      value={filtername}
                      className="main-body-top-status-bar-filter-input"
                      placeholder={t("TF No./StockID")}
                      onKeyPress={(e) =>
                        e.key === "Enter" && filterbyname(e.target.value)
                      }
                      onChange={(e) => setFiltername(e.target.value)}
                    />
                    {filtername ? (
                      <img
                        className="main-body-top-status-bar-filter-clear"
                        src={base_assets + "images/icons/False.png"}
                        onClick={(e) => {
                          setFiltername("");
                          filterbyname("");
                        }}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                    <button
                      onClick={() => filterbyname(filtername)}
                      className="main-body-top-status-bar-filter-search"
                    >
                      <i className="fa fa-search" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="main-body-top-status-bar-multi-date-picker">
                    <button className="print-export-dropdown-selected-icon d-none">
                      <img
                        src={base_url_assets + "images/icons/printer-icon.png"}
                        alt=""
                      />
                    </button>
                    <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                      <button
                        className="dropdown-toggle btn-style align-items-center d-flex"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                            stroke="currentcolor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {t(datelable)}
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-right-fix"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          className={`dropdown-item ${datelable === "Today" ? "active" : ""}`}
                          onClick={() => changeDates("Today")}
                        >
                          {t("Today")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "Yesterday" ? "active" : ""}`}
                          onClick={() => changeDates("Yesterday")}
                        >
                          {t("Yesterday")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "7days" ? "active" : ""}`}
                          onClick={() => changeDates("7days")}
                        >
                          {t("Last 7 days")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "30days" ? "active" : ""}`}
                          onClick={() => changeDates("30days")}
                        >
                          {t("Last 30 days")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "ThisMonth" ? "active" : ""}`}
                          onClick={() => changeDates("ThisMonth")}
                        >
                          {t("This Month")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "LastMonth" ? "active" : ""}`}
                          onClick={() => changeDates("LastMonth")}
                        >
                          {t("Last Month")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "Custom Range" ? "active" : ""}`}
                          onClick={() => datePickerRef.current.setOpen(true)}
                        >
                          {t("Custom Range")}
                        </li>
                      </ul>
                      <DatePicker
                        selectsRange={true}
                        monthsShown={2}
                        startDate={datefilter[0]}
                        endDate={datefilter[1]}
                        onChange={(update) => {
                          const startDate = update[0];
                          const endDate = update[1];
                          setDatelable("Custom Range");
                          if (startDate && endDate) {
                            const modifiedStartDate = new Date(startDate);
                            modifiedStartDate.setHours(0, 0, 0, 0);
                            const modifiedEndDate = new Date(endDate);
                            modifiedEndDate.setHours(23, 59, 59, 999);
                            updateCurrentStatusDate(
                              [modifiedStartDate, modifiedEndDate],
                              "Custom Range",
                            );
                          } else {
                            setDatefilter([startDate, endDate]);
                          }
                        }}
                        dateFormat="yyyy-MM-dd"
                        ref={datePickerRef}
                        autoComplete="none"
                      />
                    </div>
                    <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={
                            base_url_assets +
                            "images/icons/ellipsis-circular.png"
                          }
                          alt=""
                        />
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#stExportFormatModal"
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={
                                base_url_assets +
                                "images/icons/export-x-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <span>{t("export")}</span>
                        </li>
                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#stSampleFormatModal"
                        >
                          <div className="dropdown-item-img">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8 1.333v9.334M8 10.667L5.333 8M8 10.667L10.667 8M2.667 14h10.666"
                                stroke="#A4A4A4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <span>{t("Sample")}</span>
                        </li>
                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#columnModal"
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={
                                base_url_assets + "images/icons/column-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <span>{t("column")}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative"
                id="table-scroll"
                style={{ maxWidth: "100%", overflowX: "auto" }}
              >
                <table
                  id="transaction_subtable3"
                  className="stripe row-border order-column common-table table-striped main-table w-100"
                >
                  <thead>
                    <tr>
                      {newcolumndata?.map((col, index) => {
                        if (!col?.status) return null;
                        const sortKey = SORT_KEYS[index];
                        const active = sortConfig.key === sortKey;
                        return (
                          <th
                            key={index}
                            className={col.class}
                            onClick={
                              sortKey ? () => handleSort(sortKey) : undefined
                            }
                            style={sortKey ? { cursor: "pointer" } : undefined}
                          >
                            {t(col.lable)}
                            {sortKey ? (
                              <div className="up-down-arrow-btn">
                                <img
                                  className={
                                    "up-down-arrow-img up-down-arrow-img-forward" +
                                    (active && sortConfig.direction === "desc"
                                      ? ""
                                      : " active")
                                  }
                                  src={
                                    base_url_assets +
                                    "images/icons/up-down-arrow.png"
                                  }
                                  alt=""
                                />
                                <img
                                  className={
                                    "up-down-arrow-img up-down-arrow-img-reverse" +
                                    (active && sortConfig.direction === "desc"
                                      ? " active"
                                      : "")
                                  }
                                  src={
                                    base_url_assets +
                                    "images/icons/up-down-arrow-reverse.png"
                                  }
                                  alt=""
                                />
                              </div>
                            ) : null}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {sortedList
                        ? sortedList.map((result, key) => {
                            var status_class_val = status_transfer_class(
                              result.status.st_status,
                            );
                            var priority_class_val = status_priority(
                              result.status.priority,
                            );
                            var valueofpriority = [];
                            if (result.status.priority === 0) {
                              valueofpriority = [
                                { label: "Low", value: 0, color: "#D9D9D9" },
                              ];
                            } else if (result.status.priority === 1) {
                              valueofpriority = [
                                { label: "Medium", value: 1, color: "#D2E4FF" },
                              ];
                            } else {
                              valueofpriority = [
                                { label: "High", value: 2, color: "#FFD2D9" },
                              ];
                            }
                            var colorsArray = [];
                            var valueofstatus = [];

                            if (result.status.st_status === 1) {
                              valueofstatus = [
                                {
                                  label: "Approved",
                                  value: result.status.st_status,
                                  color: "#0ECB81",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: "Transit",
                                  value: 3,
                                  color: "#97BFD9",
                                },
                                {
                                  label: "Pending",
                                  value: 2,
                                  color: "#F9BC44",
                                },
                              ];
                            } else if (result.status.st_status === 0) {
                              valueofstatus = [
                                {
                                  label: "Canceled",
                                  value: result.status.st_status,
                                  color: "#FF5757",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: "Pending",
                                  value: 2,
                                  color: "#F9BC44",
                                },
                              ];
                            } else if (result.status.st_status === 2) {
                              valueofstatus = [
                                {
                                  label: "Pending",
                                  value: result.status.st_status,
                                  color: "#F9BC44",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: "Approved",
                                  value: 1,
                                  color: "#0ECB81",
                                },
                                {
                                  label: "Canceled",
                                  value: 0,
                                  color: "#FF5757",
                                },
                              ];
                            } else if (result.status.st_status === 4) {
                              valueofstatus = [
                                {
                                  label: "Completed",
                                  value: result.status.st_status,
                                  color: "#68B8F2",
                                },
                              ];
                            } else {
                              valueofstatus = [
                                {
                                  label: "Transit",
                                  value: result.status.st_status,
                                  color: "#97BFD9",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: "Approved",
                                  value: 1,
                                  color: "#0ECB81",
                                },
                              ];
                            }
                            return (
                              <React.Fragment key={key}>
                                <tr
                                  id={`common-main-table-wrap-${result?.id}`}
                                  key={key}
                                >
                                  <>
                                    {newcolumndata[0]?.status && (
                                      <td className="fixed-side">
                                        {" "}
                                        {result?.createdAt
                                          ? result?.createdAt
                                          : ""}{" "}
                                      </td>
                                    )}
                                    {newcolumndata[1]?.status && (
                                      <td className="po-no">
                                        <Link
                                          to={
                                            parmissiondatashow
                                              ?.inventory_transaction_stock_transfer
                                              ?.Edit
                                              ? "/app/inventory/edit-stocktransfer"
                                              : ""
                                          }
                                          state={{
                                            stockid: result?.id,
                                            transitiondate:
                                              result?.transaction_date,
                                            deliverydate:
                                              result?.delivery_date_unformated,
                                            voucher_id: result?.voucher_id,
                                            tf_no: result?.st_no,
                                            location_id:
                                              result?.transfer_to_location,
                                            stock_status:
                                              result?.status?.st_status,
                                            shipfromid:
                                              result?.transfer_from_loc,
                                            printparmission:
                                              parmissiondatashow
                                                ?.inventory_transaction_stock_transfer
                                                ?.Print,
                                          }}
                                        >
                                          {result?.st_no ? result?.st_no : ""}
                                        </Link>
                                      </td>
                                    )}
                                    {newcolumndata[2]?.status && (
                                      <td>
                                        {result?.transfer_from_loc_name
                                          ? result?.transfer_from_loc_name
                                          : ""}
                                      </td>
                                    )}
                                    {newcolumndata[3]?.status && (
                                      <td>
                                        {" "}
                                        {result?.transfer_to_location_name
                                          ? result?.transfer_to_location_name
                                          : ""}{" "}
                                      </td>
                                    )}
                                    {newcolumndata[4]?.status && (
                                      <td
                                        className="sku-col table_btn_expand_col"
                                        id={"table-btn_" + result.id}
                                        onClick={() => setSubTable(result.id)}
                                      >
                                        <div className="td-icons-wrap">
                                          <div>
                                            <img
                                              className="sku-col-arrow cursor-pointer"
                                              src={
                                                base_url_assets +
                                                "images/icons/right_green_button.png"
                                              }
                                              alt=""
                                            />
                                            <span>
                                              {result?.sku ? result?.sku : "0"}
                                            </span>
                                          </div>
                                          {result.allocatable ? (
                                            <div className="td-icons-wrap-link">
                                              <img
                                                className="img "
                                                src={
                                                  base_url_assets +
                                                  "images/icons/link-icon.svg"
                                                }
                                                alt=""
                                              />
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          <div className="tooltip-area-up">
                                            {result?.pos_Qty !== 0 ? (
                                              <div className="td-icons-wrap-user tooltip-area-up">
                                                <img
                                                  className="img"
                                                  src={
                                                    base_url_assets +
                                                    "images/icons/gray-user.png"
                                                  }
                                                  alt=""
                                                />
                                                <span className="tooltip-area-up-text">
                                                  {t("Customer")}
                                                </span>
                                                <span>{result?.pos_Qty}</span>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            <span className="tooltip-area-up-text">
                                              {result?.pos?.customer_name}
                                              {result?.pos?.customer_name ? (
                                                <br />
                                              ) : (
                                                ""
                                              )}
                                              {result?.pos?.ref}
                                              <br />
                                              {formatDate(
                                                result?.pos?.delivery_date,
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                    )}
                                    {newcolumndata[5]?.status && (
                                      <td className="col-highlight">
                                        {result?.total_quantity
                                          ? result?.total_quantity
                                          : ""}
                                      </td>
                                    )}
                                    {newcolumndata[6]?.status && (
                                      <td className="col-highlight">
                                        {result?.delivery_date
                                          ? result?.delivery_date
                                          : ""}
                                      </td>
                                    )}
                                    {newcolumndata[7]?.status && (
                                      <td className="text-end col-highlight">
                                        {result?.due_days
                                          ? result?.due_days
                                          : "0"}{" "}
                                      </td>
                                    )}
                                    {newcolumndata[8]?.status && (
                                      <td className="col-highlight">
                                        {" "}
                                        {toFormatPrice(
                                          result.total_amount,
                                          { addSymbol: true },
                                          result?.currency,
                                        )}{" "}
                                      </td>
                                    )}
                                    {newcolumndata[9]?.status && (
                                      <td className="col-highlight">
                                        <div
                                          className={
                                            "dropdown status-dropdown status-dropdown-select " +
                                            status_class_val
                                          }
                                        >
                                          <Select
                                            options={colorsArray}
                                            isDisabled={
                                              result.status.st_status === 4 ||
                                              result.status.st_status === 5
                                                ? true
                                                : false
                                            }
                                            value={valueofstatus}
                                            onChange={(event) =>
                                              select_transfer_status(
                                                key,
                                                event,
                                                result.id,
                                              )
                                            }
                                            classNamePrefix="status-dropdown-select"
                                            styles={colorStyles}
                                            getOptionLabel={(e) => (
                                              <div className="">{e.label}</div>
                                            )}
                                            isSearchable={false}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            components={{ Menu: CustomMenu }}
                                          />
                                        </div>
                                      </td>
                                    )}
                                    {newcolumndata[10]?.status && (
                                      <td className="col-highlight">
                                        <div
                                          className={
                                            "dropdown status-dropdown status-dropdown-select " +
                                            priority_class_val
                                          }
                                        >
                                          <Select
                                            options={priorityarray}
                                            value={valueofpriority}
                                            onChange={(event) =>
                                              select_transfer_priority(
                                                key,
                                                event,
                                                result.id,
                                              )
                                            }
                                            classNamePrefix="status-dropdown-select"
                                            styles={colorStyles}
                                            getOptionLabel={(e) => (
                                              <div className={e.class}>
                                                {e.label}
                                              </div>
                                            )}
                                            isSearchable={false}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            components={{ Menu: CustomMenu }}
                                          />
                                        </div>
                                      </td>
                                    )}
                                    {newcolumndata[11]?.status && (
                                      <td className="col-highlight">
                                        {result?.awb_number
                                          ? result?.awb_number
                                          : ""}{" "}
                                      </td>
                                    )}
                                    {newcolumndata[12]?.status && (
                                      <td className="col-highlight">
                                        {" "}
                                        {result?.agent_name
                                          ? result?.agent_name
                                          : ""}
                                      </td>
                                    )}
                                    {newcolumndata[13]?.status && (
                                      <td className="col-highlight">
                                        {" "}
                                        {result?.note ? result?.note : ""}
                                      </td>
                                    )}
                                    {newcolumndata[14]?.status && (
                                      <td className="col-highlight">
                                        {result?.user_actions?.created_by_name
                                          ? result?.user_actions
                                              ?.created_by_name
                                          : ""}{" "}
                                      </td>
                                    )}
                                    {newcolumndata[15]?.status && (
                                      <td className="col-highlight">
                                        {result?.user_actions?.updated_by_name
                                          ? result?.user_actions
                                              ?.updated_by_name
                                          : ""}
                                      </td>
                                    )}
                                    {newcolumndata[16]?.status && (
                                      <td>
                                        <div
                                          onClick={() =>
                                            !pdfLoadingIds.has(result?.id) &&
                                            handleOpenPDF(result?.id)
                                          }
                                          style={{
                                            opacity: pdfLoadingIds.has(
                                              result?.id,
                                            )
                                              ? 0.5
                                              : 1,
                                            pointerEvents: pdfLoadingIds.has(
                                              result?.id,
                                            )
                                              ? "none"
                                              : "auto",
                                          }}
                                        >
                                          <img
                                            className="pdf-image cursor-pointer"
                                            src={
                                              base_assets +
                                              "images/icons/pdf-icon.png"
                                            }
                                            alt="PDF"
                                          />
                                        </div>
                                      </td>
                                    )}
                                  </>
                                </tr>
                                {excuteTable ? (
                                  <>
                                    {typeof result.subTable == "undefined"
                                      ? (result.subTable = "")
                                      : result.subTable}
                                  </>
                                ) : null}
                              </React.Fragment>
                            );
                          })
                        : ""}
                    </>
                  </tbody>
                  <tfoot>
                    <tr>
                      {newcolumndata[0]?.status && <td />}
                      {newcolumndata[1]?.status && <td />}
                      {newcolumndata[2]?.status && <td />}
                      {newcolumndata[3]?.status && <td />}
                      {newcolumndata[4]?.status && <td />}
                      {newcolumndata[5]?.status && (
                        <td>
                          {" "}
                          {stocktransferlist
                            ? stocktransferlist?.reduce(
                                (interation, val) =>
                                  (interation =
                                    interation + parseInt(val.total_quantity)),
                                0,
                              )
                            : ""}
                        </td>
                      )}
                      {newcolumndata[6]?.status && <td />}
                      {newcolumndata[7]?.status && <td />}
                      {newcolumndata[8]?.status && (
                        <td>
                          {/* {toFormatPrice(
                          stocktransferlist
                            ? stocktransferlist?.reduce(
                              (interation, val) =>
                              (interation =
                                interation +
                                toUnformatPrice(val?.total_amount)),
                              0,
                            )
                            : '', { addSymbol: true }
                        )} */}
                        </td>
                      )}
                      {newcolumndata[9]?.status && <td />}
                      {newcolumndata[10]?.status && <td />}
                      {newcolumndata[11]?.status && <td />}
                      {newcolumndata[12]?.status && <td />}
                      {newcolumndata[13]?.status && <td />}
                      {newcolumndata[14]?.status && <td />}
                      {newcolumndata[15]?.status && <td />}
                      {newcolumndata[16]?.status && <td />}
                    </tr>
                  </tfoot>
                </table>
                {datalodaer && <TableLoader />}
              </div>
            </div>
            {stocktransferlist.length > 0 ? (
              <Pagination
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <SocialModal />
        <ProductModal
          data_product={Productmodaldata}
          setOneproduct={setProductmodaldata}
          editproduct_submit={""}
        />
        <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
      </div>
      <TableColumnModal
        tablehead={stocktransfertablehead}
        tblName={"tbl_inventory_stocktransfer"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={Getstocktransfer}
      ></TableColumnModal>
      <ConfirmationModel
        statement={statement}
        handler_submit={
          statement === "Change Status"
            ? Getstocktransferstatus
            : Getstocktransferpriority
        }
        handler_dismiss={Getstocktransfer}
      ></ConfirmationModel>
      <AgentModel
        handler_submit={Getstocktransferstatus}
        handler_dismiss={Getstocktransfer}
        setAgentvalue={setAgentvalue}
        setAWBvalue={setAWBvalue}
      ></AgentModel>
      <button
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#createPurchaseModal"
        id="status_query_select"
      ></button>
      <button
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#agentModal"
        id="statustransit_query_select"
      ></button>
      <div
        className="modal fade common-modal"
        id="stExportFormatModal"
        tabIndex={-1}
        aria-labelledby="stExportFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text mb-2" id="stExportFormatModalLabel">
                {t("Export format")}
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="stExportFormat"
                    value="xlsx"
                    checked={stExportFormat === "xlsx"}
                    onChange={() => setStExportFormat("xlsx")}
                  />
                  {t("Excel (.xlsx)")}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="stExportFormat"
                    value="csv"
                    checked={stExportFormat === "csv"}
                    onChange={() => setStExportFormat("csv")}
                  />
                  {t("CSV")}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => downloadexclsheet(stExportFormat)}
              >
                {t("Export")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade common-modal"
        id="stSampleFormatModal"
        tabIndex={-1}
        aria-labelledby="stSampleFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_assets + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text mb-2" id="stSampleFormatModalLabel">
                {t("Export format")}
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="stSampleFormat"
                    value="xlsx"
                    checked={stSampleFormat === "xlsx"}
                    onChange={() => setStSampleFormat("xlsx")}
                  />
                  {t("Excel (.xlsx)")}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="stSampleFormat"
                    value="csv"
                    checked={stSampleFormat === "csv"}
                    onChange={() => setStSampleFormat("csv")}
                  />
                  {t("CSV")}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => downloadSampleSheet(stSampleFormat)}
              >
                {t("Download")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Stock_transfer;
